import { Dropdown, DropdownItemProps, DropdownMenuProps, DropdownProps, Select, SelectProps } from "semantic-ui-react";

type BPSelectProps = SelectProps & {};

export function BPSelect(props: BPSelectProps) {
    return <Select {...props}>{props.children}</Select>;
}

export type BPDropdownProps = DropdownProps & {};
export function BPDropdown(props: BPDropdownProps) {
    return <Dropdown {...props}>{props.children}</Dropdown>;
}

export type BPDropdownItemProps = DropdownItemProps & {};
export function BPDropdownItem(props: BPDropdownItemProps) {
    return <Dropdown.Item {...props}>{props.children}</Dropdown.Item>;
}

type BPDropdownMenuProps = DropdownMenuProps & {};
export function BPDropdownMenu(props: BPDropdownMenuProps) {
    return <Dropdown.Menu {...props}>{props.children}</Dropdown.Menu>;
}